import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=99eb07ba&"
import script from "./BlogArticle.vue?vue&type=script&lang=ts&"
export * from "./BlogArticle.vue?vue&type=script&lang=ts&"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=99eb07ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports